import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import IconSuccessfully from 'src/Assets/Svg/successfully.svg?react'
import { InfluencerRegisterEnum } from 'src/Types/users'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'
import { useAppDispatch } from 'src/Hooks/redux'
import { setAccessToken } from 'src/Redux/auth-process/credentialsSlice'
import { influencerRegistered } from 'src/Helpers/TagManager'
import { influencerBoard } from 'src/Router/routes'
import { variables } from 'src/Styled/variables'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 40px 16px;
  gap: 8px;
`
const SuccessCircle = styled.div`
  padding-top: 8px;
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-bottom: 24px;
`
const SuccessText = styled.div`
  text-align: center;
  font-size: ${variables.fontSize18};
  line-height: 27px;
  display: grid;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.color.darkGrey};

  @media (min-width: 576px) {
    margin-bottom: 24px;
  }
`

interface LoginCreatorCompletedProps {
  status: InfluencerRegisterEnum
}

export const LoginCreatorCompleted: FC<LoginCreatorCompletedProps> = ({
  status,
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { search } = useCustomSearchParams()
  const token = search.get('authToken') || ''
  const userID = search.get('userId') || ''

  if (status !== InfluencerRegisterEnum.COMPLETED) {
    return null
  }

  const onContinueClick = (): void => {
    token &&
      dispatch(
        setAccessToken({
          token,
        }),
      )
    const queryParams = new URLSearchParams(location.search)
    if (queryParams.has('authToken')) {
      queryParams.delete('authToken')
    }
    navigate(`?${queryParams.toString()}`, { replace: true })

    userID && influencerRegistered({ userID })

    navigate(influencerBoard)
  }
  return (
    <Container>
      <SuccessCircle>
        <IconSuccessfully width={48} height={48} />
      </SuccessCircle>
      <SuccessText>Your account successfully created</SuccessText>

      <PrimaryButton onClick={onContinueClick}>Continue</PrimaryButton>
    </Container>
  )
}
